<script>
    export let data = {};
</script>

<style>
    .column {
        display: grid;
        grid-template-columns: 80px 1fr;
    }

    .icon {
        font-size: 10px;
        padding-left: 15px;
    }

    .icon img {
        width: 100%;
    }
</style>
{#if data}
<div class="column">
    <div class="icon">
        {#if data.icon}
            <img src={data.icon.url} alt={data.icon.name} />
        {/if}
    </div>
    <div class="content">
        <div class="name">{data.name}</div>
        {#if data.description}
        <div class="description">{data.description}</div>
        {/if}
    </div>
</div>
{/if}